import { takeLatest, put, call, take } from "redux-saga/effects";
import {    
    NOTIFICATION_DATA, NOTIFICATION_DATA_GET_API,
    NOTIFICATION_GET_DATA,NOTIFICATION_GET_DETAIL_API,
    NOTIFICATION_FORM_ADD_DATA,NOTIFICATION_FORM_POST_API,
    NOTIFICATION_UPDATE_DATA, NOTIFICATION_POST_API,
    NOTIFICATION_DELETE_DATA, NOTIFICATION_DELETE_API,
    NOTIFICATION_AUDIT_GET_DATA,NOTIFICATION_AUDIT_GET_API,
    
} from './Constants'
import {
    
    setNotificationDataFail, setNotificationDataSuccess,
    setNotificationGetDataFail,setNotificationGetDataSuccess,
    setNotificationFormAddDataFail,setNotificationFormAddDataSuccess, 
    setNotificationUpdateDataFail, setNotificationUpdateDataSuccess,  
    setNotificationDeleteDataFail, setNotificationDeleteDataSuccess,  
    setNotificationAuditGetDataFail, setNotificationAuditGetDataSuccess,
   
} from './Actions'
import { addErrorAlert, addSuccessAlert } from "../../alert/Actions";
import { getRequest,getDetailRequest, postRequest, putRequest, deleteRequest, postImportRequest } from "../../../shared/components/Service";


function* getNotificationDataService() {
  try {
    const getNotificationDataResponse = yield call(getRequest, NOTIFICATION_DATA_GET_API);
    const status = getNotificationDataResponse.status;
    if (status === 200) {
      const data = getNotificationDataResponse.data.data;
      yield put(setNotificationDataSuccess(data));
    } else {
      yield put(setNotificationDataFail(getNotificationDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setNotificationDataFail(error));
  }
}
function* getNotificationGetDataService({ id }) {
  try {
    const getNotificationGetDataResponse = yield call(
      getDetailRequest,
      NOTIFICATION_GET_DETAIL_API + id
    );
    const status = getNotificationGetDataResponse.status;
    if (status === 200) {
      const newData = getNotificationGetDataResponse.data.data;
      yield put(setNotificationGetDataSuccess(newData));
    } else {
      yield put(setNotificationGetDataFail(getNotificationGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setNotificationGetDataFail(error));
  }
}

function* getNotificationAuditGetDataService({ id }) {
  try {
    const getNotificationAuditGetDataResponse = yield call(
      getDetailRequest,
      NOTIFICATION_AUDIT_GET_API + id
    );
    const status = getNotificationAuditGetDataResponse.status;
    if (status === 200) {
      const newData = getNotificationAuditGetDataResponse.data;
      yield put(setNotificationAuditGetDataSuccess(newData));
    } else {
      yield put(setNotificationAuditGetDataFail(getNotificationAuditGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setNotificationAuditGetDataFail(error));
  }
}

function* postMyNotificsationFormDataService({ request }) {
  try {
    console.log("request in saga", request)
    const response = yield call(
      postRequest,
      NOTIFICATION_FORM_POST_API,
      request
    );
    //const status = myNotificationFormDataResponse.status;
    const apiData = response.data ? response.data : response;

    if (apiData.success) {
      const newData = apiData.data;
      yield put(addSuccessAlert(apiData.msg || 'Notification Created'));
      yield put(setNotificationFormAddDataSuccess(newData));
    } else {
      yield put(addErrorAlert(apiData.msg || 'Error adding Notification'));
      yield put(setNotificationFormAddDataFail(apiData.msg));
    }
  } catch (error) {
    console.error("Notification create error", error);
    yield put(addErrorAlert("Error adding Notification"));
    yield put(setNotificationDataFail(error));
  }
}
function* postNotificationDataService({ request }) {
    try {
        const response = yield call(postRequest,NOTIFICATION_POST_API, request );
        if (response.status === 200) {
            yield put(addSuccessAlert("Notification updated"))
            yield put(setNotificationUpdateDataSuccess(response.data.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg))
            yield put(setNotificationUpdateDataFail(response.response.data))
        }
    } catch (error) {
        yield put(addErrorAlert("Could not update Notification"))
        yield put(setNotificationUpdateDataFail(error))
    }
}

// delete
function* deleteNotificationDataService({ id }) {
  try {
    const response = yield call(postRequest, NOTIFICATION_DELETE_API + id);
    if (response.status === 200) {
      yield put(addSuccessAlert("Notification Inactive"))
      yield put(setNotificationDeleteDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg))
      yield put(setNotificationDeleteDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error making notification inactive"))
    yield put(setNotificationDeleteDataFail(error));
  }
}

export function* watchNotification(){
    
    yield takeLatest(NOTIFICATION_DATA.NOTIFICATION_DATA_LOAD, getNotificationDataService);
    yield takeLatest(NOTIFICATION_GET_DATA.NOTIFICATION_GET_DATA_LOAD, getNotificationGetDataService);
    yield takeLatest(NOTIFICATION_FORM_ADD_DATA.NOTIFICATION_FORM_ADD_DATA_LOAD, postMyNotificsationFormDataService);
    yield takeLatest(NOTIFICATION_UPDATE_DATA.NOTIFICATION_UPDATE_DATA_LOAD, postNotificationDataService);
    yield takeLatest(NOTIFICATION_DELETE_DATA.NOTIFICATION_DELETE_LOAD, deleteNotificationDataService);
    yield takeLatest(NOTIFICATION_AUDIT_GET_DATA.NOTIFICATION_AUDIT_GET_DATA_LOAD, getNotificationAuditGetDataService);
    
}